var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"origin-top-right absolute left-0 w-full bg-off-white shadow-lg z-40 overflow-y-scroll",style:(("max-height: " + (_vm.windowHeight - 72) + "px;top: 72px"))},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }